/*!
  Machina, by Whiley Mai
  recomendations.js
  https://whileymai.com
*/

document.addEventListener("DOMContentLoaded", function () {
  dynamicRecommendationsFunction(null);
});
document.addEventListener("shopify:section:load", function (e) {
  var target = e.target;
  dynamicRecommendationsFunction(target);
});

function dynamicRecommendationsFunction(target) {
  var recommendedSections = document.querySelectorAll(
    ".dynamic-recommendation-section"
  );
  recommendedSections.forEach(function (recommendedSection) {
    if (target != null) {
      var targetSection = target.querySelector(
        ".dynamic-recommendation-section"
      );
      if (targetSection == recommendedSection) {
        sliderRecommendedLoop(recommendedSection);
      }
    } else {
      sliderRecommendedLoop(recommendedSection);
    }
  });
  console.log('recomendations prod file loaded');
}

function sliderRecommendedLoop(recommendedSection) {
  var productRecomendationBody = recommendedSection.querySelector(".featured-related");
  //if container
  if (productRecomendationBody != null) {
    var sectionId = productRecomendationBody.dataset.sectionid;
    //var wrapper = document.querySelector('.slider-parent');
    var url = recommendedSection.dataset.url;
    //productRecomendationBody.innerHTML = '<div class="slider-container-inner"></div>';
    var sliderSelector = productRecomendationBody;
    //ASYNC FUNCTION
    //This function returns a promise
    var getProducts = async () => {
      try {
        recommendURL = url.trim(); // remove the unwanted whitespace
        var response = await fetch(recommendURL); //this operation takes some time, so we wait
        //This will return a new promise so we can call .then on the response
        var products = await response.json();
        //we pass the retruned data from products into the function
        console.log("Products loaded", products);
        return products;
      } catch (err) {
        console.log(new Error(`Unable to load products ${err.message}`));
      }
    };
    //END ASYNC FUNCTION
    //this is the data from the response
    getProducts()
      .then(({ products }) => {
        //if image is equal to or greater than 1
        if (products.length > 0) {
          //for each product
          products.forEach((product, index) => {
            var product_handle = product.handle;
            var xhttp = new XMLHttpRequest();
            xhttp.onload = function () {
              var productRow = this.response;
              sliderSelector.insertAdjacentHTML("afterbegin", productRow);
              if (products.length == index + 1) {
                var myInterval = setInterval(function () {
                  var productsList =
                    sliderSelector.querySelectorAll(".rec-products");
                  if (productsList.length == products.length) {
                    //
                    var cardStyle = recommendedSection.dataset.cardstyle;
                    var cards =
                      productRecomendationBody.querySelectorAll(".product-card-new-design");
                     if (cards.length > 0) {
                      cards.forEach(function (card) {
                        card.classList.add(cardStyle);
                      });
                    }
                    //
                    setTimeout(function(){
                     recommendedSection.classList.remove("recommendations-placeholder-active");
                    },1000);
                    recommendedSection.classList.remove("d-none");
                    sliderRecommendedProducts(sectionId, sliderSelector);
                    clearInterval(myInterval);
                    var eventRecommendation = new CustomEvent(
                      "shopify-recommendation:init-product-grid",
                      {
                        detail: { recommendations: products },
                      }
                    );
                    document.dispatchEvent(eventRecommendation);

                    // add image aspect ratio class
                    var imageRatio = recommendedSection.dataset.imageratio;
                    var images =
                      productRecomendationBody.querySelectorAll("img");
                    if (images.length > 0) {
                      images.forEach(function (image) {
                        image.classList.add(imageRatio);
                      });
                    }
                  }
                }, 1);
              }
            };
            xhttp.open(
              "GET",
              "/products/" + product_handle + "?view=recommended-product"
            );
            xhttp.send();
          });
        }
        if (products.length < 3) {
          sliderSelector.classList.add("w-100");
        }
        if (products.length == 0) {
          recommendedSection.classList.add("d-none");
        }
      })
      .catch((err) => {
        console.log("Rejected", err);
      });
  }
}
// recommended products slider
function sliderRecommendedProducts(sectionId, productRecomendationBody) {
  //row formatting
  var element = productRecomendationBody;
  var slider2 = tns({
    container: productRecomendationBody,
    items: 1,
    slideBy: "1",
    nav: false,
    speed: 400,
    gutter: 20,
    mode: "carousel",
    prevButton: "#" + sectionId + " .js-slider-sites-prev",
    nextButton: "#" + sectionId + " .js-slider-sites-next",
    navPosition: "bottom",
    autoplayButtonOutput: false,
    mouseDrag: true,
    autoplay: false,
    controls: true,
    freezable: true,
    touch: true,
    mouseDrag: true,
    preventScrollOnTouch: "true",
    rewind: true,
    lazyload: false,
    center: false,
    loop: false,
    controlsContainer: "#" + sectionId + " .recommendations-slider-controls",
    onInit(info) {
        info.container.setAttribute('tabindex', -1);
        info.controlsContainer.setAttribute('tabindex', '-1');
        info.nextButton.setAttribute('tabindex', 0);
        info.prevButton.setAttribute('tabindex', 0);
    },
    responsive: {
      320: {
        items: 1
      },
      640: {
        items: 1
      },
      768: {
        items: 2
      },
      1024: {
        items: 3
      }
    }
  });
  //slider2.goTo(1);
  slider2.refresh();
}
